import React from 'react';
import EdgeBlocks from './EdgeBlocks';

// Thin branding bar rendered at the top of the mobile player modals.
// Matches the main page navbar: `simpleOdds` wordmark (Inter, bold,
// camelCase) followed by the three colored EdgeBlocks dots.
const ModalBrandingBar = () => (
  <div
    style={{
      display: 'flex',
      alignItems: 'center',
      gap: '8px',
      padding: '8px 12px',
      backgroundColor: '#0f172a',
      color: '#f8fafc',
      borderBottom: '2px solid #f59e0b',
      flexShrink: 0,
    }}
  >
    <span
      style={{
        fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, sans-serif",
        fontSize: '1.25rem',
        fontWeight: 700,
        letterSpacing: '-0.025em',
        lineHeight: 1,
      }}
    >
      simpleOdds
    </span>
    <EdgeBlocks />
  </div>
);

export default ModalBrandingBar;
